///////////////////////////////
// class of helper functions //
///////////////////////////////

helper = (function () {
  function getSymbolChildrenDescriptions(symbolID) {
    var description = [];
    var symbols = resourceManager.getConfiguration().symbols;

    // Boards for all fruits
    // if (symbolID === symbols.Coconut.ID || symbolID === symbols.Pineapple.ID || symbolID === symbols.WaterMelon.ID || symbolID === symbols.Orange.ID || symbolID === symbols.Kiwi.ID) {
    // 	description.push( { "name": "board1", "type": "sprite", "json": { "fileName": "Symbols/Fruits/board1.png", "anchor": 0.5, x:-95, y:0} } );
    // 	description.push( { "name": "board2", "type": "sprite", "json": { "fileName": "Symbols/Fruits/board2.png", "anchor": 0.5, x:-33, y:0} } );
    // 	description.push( { "name": "board3", "type": "sprite", "json": { "fileName": "Symbols/Fruits/board3.png", "anchor": 0.5, x:30, y:0} } );
    // 	description.push( { "name": "board4", "type": "sprite", "json": { "fileName": "Symbols/Fruits/board4.png", "anchor": 0.5, x:90, y:0} } );
    // }

    // Symbols
    switch (symbolID) {
      case symbols.Jack.ID:
        {
          description.push({
            name: "fruit",
            type: "sprite",
            json: {
              fileName: "Symbols/J/J_00000.png",
              anchor: 0.5,
              x: 0,
              y: 0,
            },
          });
          description.push({
            name: "glow",
            type: "sprite",
            json: {
              fileName: "Symbols/J/J_00000.png",
              anchor: 0.5,
              x: 0,
              y: 0,
              alpha: 0,
            },
          });
        }
        break;

      case symbols.Queen.ID:
        {
          description.push({
            name: "fruit",
            type: "sprite",
            json: {
              fileName: "Symbols/Q/Q_00000.png",
              anchor: 0.5,
              x: 0,
              y: 0,
            },
          });
          description.push({
            name: "glow",
            type: "sprite",
            json: {
              fileName: "Symbols/Q/Q_00000.png",
              anchor: 0.5,
              x: 0,
              y: 0,
              alpha: 0,
            },
          });
        }
        break;

      case symbols.King.ID:
        {
          description.push({
            name: "fruit",
            type: "sprite",
            json: {
              fileName: "Symbols/K/K_00000.png",
              anchor: 0.5,
              x: 0,
              y: 0,
            },
          });
          description.push({
            name: "glow",
            type: "sprite",
            json: {
              fileName: "Symbols/K/K_00000.png",
              anchor: 0.5,
              x: 0,
              y: 0,
              alpha: 0,
            },
          });
        }
        break;

      case symbols.Ace.ID:
        {
          description.push({
            name: "fruit",
            type: "sprite",
            json: {
              fileName: "Symbols/A/A_00000.png",
              anchor: 0.5,
              x: 0,
              y: 0,
            },
          });
          description.push({
            name: "glow",
            type: "sprite",
            json: {
              fileName: "Symbols/A/A_00000.png",
              anchor: 0.5,
              x: 0,
              y: 0,
              alpha: 0,
            },
          });
        }
        break;

      case symbols.HorseShoe.ID:
        {
          description.push({
            name: "fruit",
            type: "sprite",
            json: {
              fileName: "Symbols/Statics/Symbol_Horseshoe.png",
              anchor: 0.5,
              x: 0,
              y: 0,
            },
          });
          description.push({
            name: "glow",
            type: "sprite",
            json: {
              fileName: "Symbols/Statics/Symbol_Horseshoe.png",
              anchor: 0.5,
              x: 0,
              y: 0,
              alpha: 0,
            },
          });
        }
        break;

      case symbols.Hat.ID:
        {
          // description.push( { "name": "surround", "type": "sprite", "json": { "fileName": "Symbols/Tiki/BlueTikiFrame.png", "anchor": 0.5, x:0, y:0} } );
          description.push({
            name: "mask",
            type: "sprite",
            json: {
              fileName: "Symbols/Statics/Symbol_Hat.png",
              x: 0,
              y: 0,
              anchor: 0.5,
            },
          });
          description.push({
            name: "glow",
            type: "sprite",
            json: {
              fileName: "Symbols/Statics/Symbol_Hat.png",
              x: 0,
              y: 0,
              anchor: 0.5,
              alpha: 0,
            },
          });
        }
        break;

      case symbols.Pot.ID:
        {
          // description.push( { "name": "surround", "type": "sprite", "json": { "fileName": "Symbols/Tiki/RedTikiFrame.png", "anchor": 0.5, x:0, y:0} } );
          description.push({
            name: "mask",
            type: "sprite",
            json: {
              fileName: "Symbols/Statics/Symbol_Pot.png",
              x: 0,
              y: 0,
              anchor: 0.5,
            },
          });
          description.push({
            name: "glow",
            type: "sprite",
            json: {
              fileName: "Symbols/Statics/Symbol_Pot.png",
              x: 0,
              y: 0,
              anchor: 0.5,
              alpha: 0,
            },
          });
        }
        break;

      case symbols.Title.ID:
        {
          //  description.push( { "name": "surround", "type": "sprite", "json": { "fileName": "Symbols/Tiki/GreenTikiFrame.png", "anchor": 0.5, x:0, y:0} } );
          description.push({
            name: "mask",
            type: "sprite",
            json: {
              fileName: "Symbols/Statics/Symbol_Title.png",
              x: 0,
              y: 0,
              anchor: 0.5,
            },
          });
          description.push({
            name: "glow",
            type: "sprite",
            json: {
              fileName: "Symbols/Statics/Symbol_Title.png",
              x: 0,
              y: 0,
              anchor: 0.5,
              alpha: 0,
            },
          });
        }
        break;

      case symbols.Bonus.ID:
        {
          description.push({
            name: "mask",
            type: "sprite",
            json: {
              fileName: "Symbols/Statics/Symbol_Bonus.png",
              x: 0,
              y: 0,
              anchor: 0.5,
            },
          });
          description.push({
            name: "glow",
            type: "sprite",
            json: {
              fileName: "Symbols/Statics/Symbol_Bonus.png",
              x: 0,
              y: 0,
              anchor: 0.5,
              alpha: 0,
            },
          });
        }
        break;

      case symbols.Wild.ID:
        {
          description.push({
            name: "mask",
            type: "sprite",
            json: {
              fileName: "Symbols/Statics/Symbol_Wild.png",
              x: 0,
              y: 0,
              anchor: 0.5,
            },
          });
          description.push({
            name: "glow",
            type: "sprite",
            json: {
              fileName: "Symbols/Statics/Symbol_Wild.png",
              x: 0,
              y: 0,
              anchor: 0.5,
              alpha: 0,
            },
          });
        }
        break;
    }

    return description;
  }

  function getSymbolName(symbolID) {
    var symbols = resourceManager.getConfiguration().symbols;

    for (const symbol of Object.entries(symbols)) {
      if (symbol[1].ID === symbolID) {
        return;
      }
    }
  }

  function getCollectSymbolPos() {
    const array = [];
    for (let i = 0; i < gameController.symbolMap.length; i++) {
      const symId = gameController.symbolMap[i].symbolId;
      if (symId === 14 || symId === 34 || symId === 54 || symId === 74 || symId === 94) {
        const reelsInfo = gameController.symbolMap[i].cell;
        const xPos = resourceManager.get(`slotContainer:reelContainer:reel${reelsInfo.reel}`);
        const yPos = resourceManager.get(`slotContainer:reelContainer:reel${reelsInfo.reel}:symbol${reelsInfo.row}`);

        const pos = {
          x: xPos.x,
          y: yPos.y + xPos.y - 20,
        };
        array.push(pos);
      }
    }
    return array;
  }

  function getCollectSymbolsReelsInfo() {
    const coinIDs = [
      100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122,
      123, 124, 125, 126, 127, 128, 129,
    ];

    const array = [];
    for (let i = 0; i < gameController.symbolMap.length; i++) {
      const symId = gameController.symbolMap[i].symbolId;
      if (symId === 14 || symId === 34 || symId === 54 || symId === 74 || symId === 94) {
        const reelsInfo = gameController.symbolMap[i].cell;

        const cell = {
          reel: reelsInfo.reel,
          row: reelsInfo.row,
        };
        array.push({ symbolId: symId, cell: cell });
      } else if (coinIDs.includes(symId)) {
        const reelsInfo = gameController.symbolMap[i].cell;

        const cell = {
          reel: reelsInfo.reel,
          row: reelsInfo.row,
        };
        array.push({ symbolId: symId, cell: cell });
      } else if (symId === 12 || symId === 32 || symId === 52 || symId === 72 || symId === 92) {
        const reelsInfo = gameController.symbolMap[i].cell;

        const cell = {
          reel: reelsInfo.reel,
          row: reelsInfo.row,
        };
        array.push({ symbolId: symId, cell: cell });
      } else if (symId === 19 || symId === 39 || symId === 59 || symId === 79 || symId === 99) {
        const reelsInfo = gameController.symbolMap[i].cell;

        const cell = {
          reel: reelsInfo.reel,
          row: reelsInfo.row,
        };
        array.push({ symbolId: symId, cell: cell });
      }
    }
    return array;
  }

  function getSymbolTexture(symbolId) {
    const symbols = resourceManager.getConfiguration().symbols;
    for (const symbol of Object.entries(symbols)) {
      if (symbol[1].ID === symbolId) {
        return symbol[1].texture;
      }
    }
    return undefined;
  }

  function getCoinSymbolsFromReel() {
    const array = [];
    const coinIDs = [
      100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122,
      123, 124, 125, 126, 127, 128, 129,
    ];

    for (let i = 0; i < gameController.symbolMap.length; i++) {
      const symId = gameController.symbolMap[i].symbolId;
      if (coinIDs.includes(symId)) {
        array.push(gameController.symbolMap[i]);
      }
    }
    return array;
  }

  function getCollectSymbolPosCenter() {
    const array = [];
    for (let i = 0; i < gameController.symbolMap.length; i++) {
      const symId = gameController.symbolMap[i].symbolId;
      if (symId === 14 || symId === 34 || symId === 54 || symId === 74 || symId === 94) {
        const reelsInfo = gameController.symbolMap[i].cell;
        const xPos = resourceManager.get(`slotContainer:reelContainer:reel${reelsInfo.reel}`);
        const yPos = resourceManager.get(`slotContainer:reelContainer:reel${reelsInfo.reel}:symbol${reelsInfo.row}`);

        const pos = {
          x: xPos.x + yPos.width / 2,
          y: yPos.y + xPos.y + yPos.symbol.height / 2,
        };
        array.push(pos);
      }
    }
    return array;
  }

  function getCenterSymbolsPos(reel, row) {
    const xPos = resourceManager.get(`slotContainer:reelContainer:reel${reel}`);
    const yPos = resourceManager.get(`slotContainer:reelContainer:reel${reel}:symbol${row}`);

    const pos = {
      x: xPos.x + yPos.width / 2,
      y: yPos.y + xPos.y + yPos.symbol.height / 2,
    };

    return pos;
  }

  function getCoinSymbolsPos(reel, row) {
    const xPos = resourceManager.get(`slotContainer:reelContainer:reel${reel}`);
    const yPos = resourceManager.get(`slotContainer:reelContainer:reel${reel}:symbol${row}`);

    const pos = {
      x: xPos.x + yPos.symbol.width / 2,
      y: yPos.y + xPos.y + yPos.symbol.height / 1.5,
    };

    return pos;
  }

  function getSymbol(reel, row) {
    return resourceManager.get(`slotContainer:reelContainer:reel${reel}:symbol${row}`);
  }

  function getCoinSymbolsFromReelPosition(reel, row) {
    for (let i = 0; i < gameController.symbolMap.length; i++) {
      const symbol = gameController.symbolMap[i];
      if (symbol.cell.reel === reel && symbol.cell.row === row) {
        return symbol;
      }
    }
  }

  function isPotOnReel(reel, row) {
    for (let i = 0; i < gameController.symbolMap.length; i++) {
      const symbol = gameController.symbolMap[i];
      if (symbol.cell.reel === reel && symbol.cell.row === row) {
        const symId = symbol.symbolId;
        if (symId === 19 || symId === 39 || symId === 59 || symId === 79 || symId === 99) {
          return true;
        } else {
          return false;
        }
      }
    }
    return false;
  }

  function symbolCreationCallback(reelIndex, symbolID, offset) {
    var childContainer = slotMachine.reels[reelIndex].symbolSprites[offset].children[0].children[0].children;
    var glow;
    if (childContainer.length > 0) {
      for (var i = 0; i < childContainer.length; i++) {
        if (childContainer[i].Props.ID.indexOf("glow") !== -1) {
          glow = childContainer[i];
          glow.blendMode = PIXI.BLEND_MODES.ADD;
        }
      }
    }
  }

  function updateHelpPageSymbols() {
    // Here we go through help pages and add children
    for (var i = 0; i < 9; i++) {
      var symbolName =
        "helpPageScroll:scrollArea:scrollContainer:paytables:paytableContainer:payTable" + (i + 1) + ":symbolGraphic";
      var symbol = resourceManager.get(symbolName);

      var childDescriptions = getSymbolChildrenDescriptions(i);
      for (j = 0; j < childDescriptions.length; j++) {
        var child = resourceManager.createObject(
          childDescriptions[j].type,
          childDescriptions[j].name,
          symbol.name,
          childDescriptions[j].json
        );
      }
    }
  }

  function updateHelpWinlineText() {
    // winlines are now split across two pages

    // page 1
    for (var i = 1; i <= 20; i++) {
      let winlineTextName =
        "helpPageScroll:scrollArea:scrollContainer:winlinesContainer:winlineContainer" + i + ":winlineText" + i;
      let winlineText = resourceManager.get(winlineTextName);
      winlineText.setText(i);
    }
  }

  function displayCurveAsLine(start, end, containerName, step, P0, P3) {
    //curve visualisation as continuous line rather than points

    var startPos = InterpolationHelper.CatmullRom(P0, start, end, P3, 0);

    var endPos = {};

    for (var i = 0; i < 1; i += step) {
      endPos = InterpolationHelper.CatmullRom(P0, start, end, P3, i);

      var lineSeg = new PIXI.Graphics();

      lineSeg.lineStyle(2, 0x000000);
      lineSeg.moveTo(startPos.x, startPos.y);
      lineSeg.lineTo(endPos.x, endPos.y);
      lineSeg.endFill();

      startPos = endPos;

      resourceManager.getContainer(containerName).addChild(lineSeg);
    }
  }

  function linearInterpolate(P1, P2, delta) {
    var x = P1.x + (P2.x - P1.x) * delta;
    var y = P1.y + (P2.y - P1.y) * delta;

    return { x: x, y: y };
  }

  function GeneratorPotSpinsVariationSplitMix32(a) {
    return function () {
      a |= 0;
      a = (a + 0x9e3779b9) | 0;
      let t = a ^ (a >>> 16);
      t = Math.imul(t, 0x21f0aaad);
      t = t ^ (t >>> 15);
      t = Math.imul(t, 0x735a2d97);
      return ((t = t ^ (t >>> 15)) >>> 0) / 4294967296;
    };
  }

  /**
   * Get the local pos relative to target container
   */
  // function getLocalFromGlobalPosition(targetToCopy, targetToSet, positioningSpine = false) {
  //   const global = targetToCopy.getGlobalPosition();
  //   let local = targetToSet.parent.toLocal(global);

  //   if (positioningSpine) {
  //     const symbolContainer = resourceManager.get(`${targetToCopy.name}:symbol`);
  //     let symbolContainerOriginalChildren;
  //     if (symbolContainer) {
  //       symbolContainerOriginalChildren = symbolContainer.children.slice();
  //       symbolContainer.children = [];
  //     }

  //     let targetToCopyParentScale = 1;
  //     // if the parents are the same then don't worry about scale (already scaled)
  //     if (targetToCopy.parent !== targetToSet.parent) {
  //       targetToCopyParentScale = targetToCopy.parent.scale.x;
  //     }

  //     local.x += (targetToCopy.width * targetToCopyParentScale) / 2;
  //     local.y += (targetToCopy.height * targetToCopyParentScale) / 2;

  //     if (symbolContainer) {
  //       symbolContainer.children = symbolContainerOriginalChildren;
  //     }
  //   }

  //   return local;
  // }

  function getLocalVisualCenter(displayObject) {
    const bounds = displayObject.getLocalBounds();

    return {
      x: bounds.x + bounds.width / 2,
      y: bounds.y + bounds.height / 2,
    };
  }

  function getLocalFromGlobalPosition(targetToCopy, targetToSet, useVisualCenter = true) {
    let symbolContainer;
    let symbolContainerOriginalChildren;

    // temp remove children if it's a symbol container (sometimes the children make the symbols wifth/height bigger)
    symbolContainer = resourceManager.get(`${targetToCopy.name}:symbol`);
    if (symbolContainer) {
      symbolContainerOriginalChildren = symbolContainer.children.slice();
      symbolContainer.children = [];
    }

    let local;

    if (useVisualCenter) {
      const copyLocalCenter = getLocalVisualCenter(targetToCopy);
      const copyGlobalCenter = targetToCopy.toGlobal(copyLocalCenter);

      local = targetToSet.parent.toLocal(copyGlobalCenter);

      const setLocalCenter = getLocalVisualCenter(targetToSet);
      local.x -= setLocalCenter.x;
      local.y -= setLocalCenter.y;
    } else {
      const global = targetToCopy.getGlobalPosition();
      local = targetToSet.parent.toLocal(global);
    }

    if (symbolContainer) {
      symbolContainer.children = symbolContainerOriginalChildren;
    }

    return local;
  }

  function getLocalFromGlobalScale(targetToCopy, targetToSet) {
    // Get world scales
    const globalScale = getWorldScale(targetToCopy);
    const parentWorldScale = getWorldScale(targetToSet.parent);

    // Convert global scale into local (relative) scale
    return {
      x: globalScale.x / parentWorldScale.x,
      y: globalScale.y / parentWorldScale.y,
    };
  }

  //extract world scale from an object
  function getWorldScale(displayObject) {
    const wt = displayObject.worldTransform;
    // The worldTransform matrix looks like:
    // [ a, c, tx ]
    // [ b, d, ty ]
    // where scaleX = sqrt(a² + b²), scaleY = sqrt(c² + d²)
    const scaleX = Math.sqrt(wt.a * wt.a + wt.b * wt.b);
    const scaleY = Math.sqrt(wt.c * wt.c + wt.d * wt.d);
    return { x: scaleX, y: scaleY };
  }

  return {
    displayCurveAsLine: displayCurveAsLine,
    getSymbolChildrenDescriptions: getSymbolChildrenDescriptions,
    symbolCreationCallback: symbolCreationCallback,
    updateHelpPageSymbols: updateHelpPageSymbols,
    updateHelpWinlineText: updateHelpWinlineText,
    linearInterpolate: linearInterpolate,
    getCoinSymbolsPos: getCoinSymbolsPos,
    getSymbolName: getSymbolName,
    getCenterSymbolsPos: getCenterSymbolsPos,
    getCollectSymbolPos: getCollectSymbolPos,
    getCollectSymbolPosCenter: getCollectSymbolPosCenter,
    getCoinSymbolsFromReel: getCoinSymbolsFromReel,
    getSymbol: getSymbol,
    getCoinSymbolsFromReelPosition: getCoinSymbolsFromReelPosition,
    getSymbolTexture: getSymbolTexture,
    getCollectSymbolsReelsInfo: getCollectSymbolsReelsInfo,
    isPotOnReel: isPotOnReel,
    GeneratorPotSpinsVariationSplitMix32: GeneratorPotSpinsVariationSplitMix32,
    getLocalFromGlobalPosition: getLocalFromGlobalPosition,
    getLocalFromGlobalScale: getLocalFromGlobalScale,
  };
})();
